import React, { useState } from "react";
import { UserModel } from "@/db/schema";
import { usePathname } from "next/navigation";
import LoginLogoutMenu from "./LoginLogoutMenu";
import usePwaStatus from "@/helpers/usePwaStatus";
import Link from "next/link";
import SvgIcons from "./SvgIcons";
import "./FooterSticky.css";


interface FooterStickyProps {
    profile: UserModel | undefined | null;
    logIn: () => void;
    logOut: () => void;
}

const { ReorderIcon } = SvgIcons();

const FooterSticky: React.FC<FooterStickyProps> = ({ profile, logIn, logOut }) => {
    const { isPWA } = usePwaStatus();
    const pathname = usePathname();
    const [expandNavbar, setExpandNavbar] = useState(false);

    return (
        <div className={`footerSticky ${isPWA ? 'is-pwa' : ''}`}>
            {isPWA && (
                <>
                    <div className='footerNavbarContainer'>
                        <div className={`footerNavbar`} id={expandNavbar ? 'openFooter' : 'closeFooter'}>
                            <div className="toggleButton">
                                <button
                                    onClick={() => {
                                        setExpandNavbar((prev) => !prev);
                                    } }>
                                    <ReorderIcon width="18px" height="18px" />
                                </button>
                            </div>
                            <div className="menuContainer">
                                <div className="links">
                                    <Link href="/" prefetch={true} className={pathname! === '/' ? 'active' : ''}> Home </Link>
                                    <Link href="/projects" prefetch={true} className={pathname?.startsWith('/project') ? 'active' : ''}> Projects </Link>
                                    <Link href="/education" prefetch={true} className={pathname?.startsWith('/education') ? 'active' : ''} id='educationTopMenu'> Education </Link>
                                    <Link href="/work" prefetch={true} className={pathname?.startsWith('/work') ? 'active' : ''} id='workTopMenu'> Work </Link>
                                    <Link href="/skills-and-trainings" prefetch={true} className={pathname?.startsWith('/skills-and-trainings') ? 'active' : ''}> Skills & Trainings</Link>
                                    <Link href="/games" prefetch={true} className={pathname?.startsWith('/game') ? 'active' : ''}> Games </Link>
                                    <Link href="/blog" prefetch={true} className={pathname?.startsWith('/blog') ? 'active' : ''}> Blog </Link>
                                    <Link href="/contact" prefetch={true} className={pathname?.startsWith('/contact') ? 'active' : ''}> Contact </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="privacyterms">
                        <Link href="/toc.html">Terms and Conditions</Link> &nbsp; <span style={{ color: '#448' }}>|</span> &nbsp; <Link href="/privacy.html">Privacy Policy</Link>
                    </span>
                </>
            )}
            <LoginLogoutMenu profile={profile} logIn={logIn} logOut={logOut} footer={true} />
        </div>
    );
}

export default FooterSticky;
